import axios from 'axios';
import { getHeaders } from './utils';
import { AULA_ASSIGNMENTS } from '../../constants/endpoints';

const close = ({ accessToken, spaceId, assignment }) => {
  const assignmentId = assignment.externalId;
  const url = `${AULA_ASSIGNMENTS()}/${assignmentId}/close`;

  return axios.post(
    url,
    {
      classId: spaceId,
      ...assignment,
    },
    { headers: getHeaders(accessToken) }
  );
};

export default close;
